import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

import { FilterField } from 'src/app/shared/interfaces';
import { FilterModalService } from './filter-modal/filter-modal.service';

import { SearchAction } from 'src/app/shared/interfaces/search.interface';
import { SessionService } from 'src/app/shared/services/session.service';
import { checkPermission } from 'src/app/shared/services/permission.service';
import { copy } from 'src/app/shared/utils';

@Component({
  selector: 'app-search-header',
  templateUrl: './search-header.component.html',
  styleUrls: ['./search-header.component.scss']
})
export class SearchHeaderComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() iconCls: string = null;
  @Input() filter: FilterField[];
  @Input() canReturnBtn = false;
  @Input() showSearchDefault = true;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onReturn = new EventEmitter();
  @Output() actionsClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() search: EventEmitter<Params> = new EventEmitter();

  public actionList: SearchAction[] = [];
  public searchValue = '';
  private subRoute: Subscription;
  private params: Params;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private filterModal: FilterModalService
  ) { }

  @Input()
  public set actions(actions: SearchAction[]) {
    this.actionList = [];

    this.sessionService.userData().subscribe(userData => {
      this.actionList = actions.filter(action => {
        if (action.permission) {
          const [namespace, actionName] = action.permission;
          return userData.permissions.some(perm => checkPermission(perm, namespace, actionName));
        }

        return true;
      });
    });
  }

  public ngOnInit(): void {
    this.subRoute = this.route.queryParams.subscribe(params => {
      this.params = params;
      this.searchValue = '';

      if (params['search']) {
        this.searchValue = params['search'];
      }
    });
  }

  public ngOnDestroy(): void {
    this.subRoute.unsubscribe();
  }

  public executeSearch(_event: Event): void {
    const params = copy(this.params);
    if (!!this.searchValue) {
      params['search'] = this.searchValue;
    } else {
      delete params.search;
    }

    this.search.emit(params);
  }

  public openFilter(event: Event): void {
    this.filterModal.show(this.filter).then(params => this.search.emit(params));
  }

  public return(event: Event): void {
    if (this.onReturn.observers.length > 0) {
      this.onReturn.emit(event);
    } else {
      this.location.back();
    }
  }
}
